import React, { createContext, useState } from 'react';

export const AddSongContext = createContext();

export const AddSongProvider = ({ children }) => {
  const [songsToAdd, setSongsToAddSongs] = useState([]);
  return <AddSongContext.Provider value={[songsToAdd, setSongsToAddSongs]}>{children}</AddSongContext.Provider>;
};
